module.exports = __webpack_public_path__ + "img/popup-btn-guest-login.93ef5b1.png";